import { MusicContext } from "@/contexts/MusicContext";
import { SubscribedContext } from "@/providers/Subscribed";
import { getContentArtwork } from "@/utils";
import { Pause, PlayArrow } from "@mui/icons-material";
import { Box, CardMedia, IconButton } from "@mui/material";
import { useContext } from "react";

export default function SongCard({ content }) {
  const { currentSong, music, handlePlay, isPlaying, handlePause } =
    useContext(MusicContext);

  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const handleClickPlay = () => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    } else {
      handlePlay(content);
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      <CardMedia
        component="img"
        sx={{
          borderRadius: 3,
          aspectRatio: "1/1",
        }}
        src={getContentArtwork(content)}
      />

      {/* Play button at bottom right when musicEl exists */}

      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 20,
          zIndex: 1,
        }}
      >
        {isPlaying && currentSong?.key === content.key ? (
          <IconButton
            onClick={handlePause}
            sx={{
              backgroundColor: "rgba(0,0,0,0.6)",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
            size="large"
          >
            <Pause sx={{ color: "white" }} />
          </IconButton>
        ) : (
          <IconButton
            onClick={handleClickPlay}
            sx={{
              backgroundColor: "rgba(0,0,0,0.6)",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
            size="large"
          >
            <PlayArrow color="white" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
